<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    class="temporary-position"
  >
    <md-card
      :class="[{ 'md-elevation-20': mouseEnter }]"
      class="snew-request-card"
    >
      <div v-if="typeOfItem === 'GIVE'" class="card-header">
        <md-avatar class="little-header-avatar-give">
          <img src="../../../public/img/little-header-icons/item-header.png" alt="Item" />
        </md-avatar>
        <span class="md-title">Item</span>
        <img src="../../../public/img/item-give-card-header.png" alt="card-header-img" class="card-header-image" />
      </div>
      <div v-else class="card-header">
        <md-avatar class="little-header-avatar-receive">
          <img src="../../../public/img/little-header-icons/item-header.png" alt="Item" />
        </md-avatar>
        <span class="md-title">Item</span>
        <img src="../../../public/img/item-receive-card-header.png" alt="card-header-img" class="card-header-image" />
      </div>
      <md-card-header>
        <router-link :to="`/s-app/profile-page/${getUserId}`">
          <SUserAvatar
            :myUser="item.request.sUser"
            size="small"
            :isProfileAvatar="false"
          />
        </router-link>

        <div class="md-title">
          <router-link :to="`/s-app/profile-page/${getUserId}`">
            {{ getUserName(item.request.sUser) }}
          </router-link>
          <span class="trade-item-text" v-html="tradeText" />
        </div>
      </md-card-header>

      <md-card-content>
        <div class="item-content">
          <div>
            <router-link :to="`/s-app/item-details/${getItemId}`">
              <img
                class="item-image"
                :src="getItemImagePath(item.request.item)"
                alt="Item"
              />
            </router-link>
          </div>
          <div class="item-info">
            <div class="item-title">
              <router-link :to="`/s-app/item-details/${getItemId}`">
                {{ item.request.item.title }}
              </router-link>
            </div>
            <div class="item-price" v-html="getRequestItemValue"></div>
          </div>
        </div>

        <div
          class="item-accept-reject-request"
          v-if="accept_state == 'WAITING_ACCEPT'"
        >
          <md-button
            class="md-icon-button md-raised md-fab md-primary"
            @click.prevent="accept"
            :data-cy="`acceptOption-${item.request.item.title}`"
          >
            <md-icon>done</md-icon>
          </md-button>
          <md-button
            class="md-icon-button md-raised md-fab md-primary"
            @click.prevent="decline(item.request)"
            :data-cy="`declineOption-${item.request.item.title}`"
          >
            <md-icon>close</md-icon>
          </md-button>
        </div>

        <div
          class="accepted-item-user"
          v-if="accept_state === 'ACCEPTED'"
          :data-cy="`acceptResult-${item.request.item.title}`"
        >
          <md-icon>task_alt</md-icon>
          {{ accept_text }}
        </div>
        <div
          class="dennied-item-user"
          v-if="accept_state === 'DECLINED'"
          :data-cy="`declineResult-${item.request.item.title}`"
        >
          <md-icon>cancel</md-icon>
          {{ accept_text }}
        </div>
        <div class="dennied-item-user" v-if="accept_state === 'ERROR'">
          <md-icon>cancel</md-icon>
          {{ responseError }}
        </div>

        <hr />

        <SCardChat
          :partner="item.request.sUser"
          :usrMessages="tradeMessages"
          :item="item.request.item"
          ref="cardChat"
        />
      </md-card-content>

      <LoadingSpinner
        position="absolute"
        v-if="accept_state === 'PROCESSING'"
      />
    </md-card>
  </div>
</template>

<script>
import moment from "moment";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import itemType from "@/enum/item-type";
import SCardChat from "@/material-components/organisms/SCardChat.vue";
import itemStatus from "@/enum/item-status";
import requestSituation from "@/enum/request-situation";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
export default {
  name: "SNewItemRequest",
  props: ["item"],
  mixins: [UserHelperVue, ItemHelperVue, ChatHelperVue, PointsHelperVue],
  data() {
    return {
      accept_state: "WAITING_ACCEPT",
      declineNotification: "",
      acceptNotification: "",
      reqSituation: requestSituation,
      accept_text: "",
      responseError: "",
      otherRequests: [],
      mouseEnter: false,
    };
  },
  components: {
    LoadingSpinner,
    SCardChat,
    SUserAvatar,
  },
  methods: {
    setNotification() {
      const type = this.item.request.item.type;
      if (type === itemType.GIVE || type === itemType.LEND) {
        this.acceptNotification = `Hi, I accepted your request for the item ${this.item.request.item.title}`;
        this.declineNotification = `Hi, I didn't accept your request for the item ${this.item.request.item.title}`;
      } else {
        this.acceptNotification = `Hi, I accepted your offer for the item ${this.item.request.item.title}`;
        this.declineNotification = `Hi, I didn't accept your offer for the item ${this.item.request.item.title}`;
      }
    },
    async makeAcceptRequests() {
      const response = await this.acceptItemRequest({
            request: this.item.request,
          });
      let updatedItemStatus = this.item.request.item;
      updatedItemStatus.status = itemStatus.WAITING;
      await this.updateItemStatus({ item: updatedItemStatus });
      await this.postUserItemMessage({
        partner: this.item.request.sUserId,
        item: this.item.request.itemId,
        postMsg: this.acceptNotification,
        newChat: true,
      });
      await this.rejectEveryOtherRequest();
      return response
    },
    handleSuccessResponse(type) {
      if (type === itemType.GIVE || type === itemType.LEND) {
        this.accept_text = "Request accepted";
        this.accept_state = "ACCEPTED";
      } else {
        this.accept_text = "Offer accepted";
        this.accept_state = "ACCEPTED";
      }
    },
    handleErrorResponse(payWith, transfer) {
      if (payWith === "money") {
        this.responseError = "Something went wrong!";
      } else {
        if (transfer.result === "Available point balance is not enough") {
          this.responseError = transfer.result;
        } else {
          this.responseError = "Something went wrong!";
        }
      }
      this.accept_state = "ERROR";
    },
    async accept() {
      this.accept_state = "PROCESSING";
      this.$refs.cardChat.hideResponse();
      this.setNotification();
      const type = this.item.request.item.type;
      let response = null;
      let pointsReceiverId = null;
      let pointsGiverId = null;
      let valuePoints =
        this.item.request.item.points || this.item.request.item.cash;
      let note = null;
      let transfer = null;
      let payWith = this.item.request.payWith;
      try {
        if (payWith === "money" || payWith === null) {
          response = await this.makeAcceptRequests();
        } else {
          pointsReceiverId =
            type === itemType.GIVE || type === itemType.LEND
              ? this.item.request.item.posterId
              : this.item.request.sUserId;
          pointsGiverId =
            type === itemType.GIVE || type === itemType.LEND
              ? this.item.request.sUserId
              : this.item.request.item.posterId;
          note = `trade accepted for the item <a href="/s-app/item-details/${this.item.request.item.id}">${this.item.request.item.title}</a>`;
          transfer = await this.transferPoint({
            to_id: pointsReceiverId,
            from_id: pointsGiverId,
            value: valuePoints,
            note: note,
          });
          if (transfer.result !== "Available point balance is not enough") {
            response = await this.makeAcceptRequests();
          }
        }
      } catch (error) {
        console.log(error);
      }
      if (response === 200) {
        this.handleSuccessResponse(type);
      } else {
        this.handleErrorResponse(payWith, transfer);
      }
      this.$refs.cardChat.scrollToBottom();
    },
    async decline(request) {
      this.accept_state = "PROCESSING";
      this.$refs.cardChat.hideResponse();
      this.setNotification();
      let response = null;
      try {
        response = await this.declineItemRequest({
          request: request,
        });
        let updatedItemStatus = request.item;
        updatedItemStatus.status = itemStatus.IDLE;
        await this.updateItemStatus({ item: updatedItemStatus });
        await this.postUserItemMessage({
          partner: request.sUserId,
          item: this.item.request.itemId,
          postMsg: this.declineNotification,
          newChat: true,
        });
      } catch (error) {
        console.log(error);
      }

      this.$refs.cardChat.scrollToBottom();
      if (response === 200) {
        this.accept_text = "Request declined.";
        this.accept_state = "DECLINED";
      } else {
        this.responseError = "Something went wrong!";
        this.accept_state = "ERROR";
      }
    },
    async rejectEveryOtherRequest() {
      this.setNotification();
      this.otherRequests.forEach((request) => {
        try {
          this.postUserItemMessage({
            partner: request.sUserId,
            item: request.itemId,
            postMsg: this.declineNotification,
            newChat: true,
          });
        } catch (error) {
          console.log(error);
        }
      });
    },
    getOtherRequests() {
      return this.itemRequestsReceived.filter((request) => {
        return (
          request.itemId === this.item.request.item.id &&
          request.situation === this.reqSituation.OPEN &&
          request.id !== this.item.request.id
        );
      });
    },
  },
  computed: {
    tradeText() {
      const type = this.item.request.item.type;
      return type === itemType.GIVE || type === itemType.LEND
        ? "requested something<br/> from you <span class='request-item-time'>" +
            moment(this.item.createdAt).fromNow() +
            "</span>"
        : "offered something<br/> to you <span class='request-item-time'>" +
            moment(this.item.createdAt).fromNow() +
            "</span>";
    },
    typeOfItem() {
      const type = this.item.request.item.type;
      return type === itemType.GIVE || type === itemType.LEND
        ? "GIVE"
        : "RECEIVE"
    },
    getRequestItemValue() {
      const payWith = this.item.request.payWith;
      if (
        this.item.request.item.cash === 0 &&
        this.item.request.item.points === 0
      ) {
        return "<span class='item-price'>FREE</span>";
      }
      return payWith === "money"
        ? `<span class="item-price-value">$${this.item.request.item.cash}</span>`
        : `<span class="item-price-value">
            <i class="material-icons mr-1">hexagon</i>
            ${this.item.request.item.points}
          </span>`;
    },
    tradeMessages() {
      return this.userMessages.find((item) => {
        return item.key.id === this.item.request.itemId;
      });
    },
    getUserId() {
      return this.item.request.sUser.id !== undefined
        ? this.item.request.sUser.id
        : "";
    },
    getItemId() {
      return this.item.request.item.id !== undefined
        ? this.item.request.item.id
        : "";
    },
  },
  mounted() {
    setTimeout(() => {
      this.otherRequests = [...this.getOtherRequests()];
    }, 501);
  },
};
</script>

// default card size
<style lang="scss" scoped>
.snew-request-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 280px;
  max-width: 100%;
  height: 558px;
  border-radius: 4px;
  border: 1px solid $grey;
}
.md-title {
  font-size: 14px;
}
.md-title a,
.item-info a {
  color: $black;
}
.md-title a:hover,
.item-info a:hover {
  color: $primary;
}
.item-title {
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 140px;
}
</style>

<style lang="scss" scoped>
.temporary-position {
  width: 100%;
  display: flex;
  justify-content: center;
}
.md-large {
  min-width: 100px !important;
  min-height: 100px !important;
}
.trade-item-text {
  font-weight: normal;
}
.item-content {
  display: flex;
  align-items: center;
  border-end-end-radius: 15px;
  border-top-right-radius: 15px;
  border: 2px solid $tertiary;
  padding: 5px;
}
.snew-request-card .md-card-content {
  padding-bottom: 14px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.item-info {
  padding: 0 10px 10px 10px;
  margin-top: -15px;
  max-width: 100%;
}
.accepted-item-user,
.dennied-item-user {
  word-break: break-all;
  margin: 2rem 0 2rem 0;
  text-align: center;
}
.accepted-item-user i {
  color: $primary !important;
}
.dennied-item-user i {
  color: $danger !important;
}
.item-image {
  width: fit-content;
  height: 90px;
  object-fit: contain;
}
.md-card .md-title {
  line-height: unset;
}
.md-title a {
  font-weight: bold;
}
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
}
.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}
.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px !important;
  z-index: 2;
}
.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 75%;
}
.little-header-avatar-give {
  border-radius: 0;
  background-color: $tertiary !important;
}
.little-header-avatar-receive {
  border-radius: 0;
  background-color: $offer !important;
}
</style>

<style lang="scss">
.request-item-time {
  font-weight: bold;
}
.item-price-value {
  margin-top: 0.5rem;
  display: flex;
  font-weight: bold;
  align-items: center;
  i {
    color: $primary;
  }
}
</style>

<style lang="scss">
.item-accept-reject-request {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 1rem;
  .md-button:last-child {
    margin-left: 12px;
  }
  .md-button:first-child .md-ripple {
    background: $primary;
  }
  .md-button:last-child .md-ripple {
    background: $danger;
  }
  i {
    color: $white !important;
  }
}
</style>
